import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErreurApi } from '../api/client';
import { useAuth } from '../auth/contexte';
import { Champ } from '../composants/Champ';
import { BandeauAlerte } from '../composants/BandeauAlerte';

export function Connexion() {
  const { connexion } = useAuth();
  const naviguer = useNavigate();
  const [login, setLogin] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [occupe, setOccupe] = useState(false);

  async function soumettre(evenement: FormEvent) {
    evenement.preventDefault();
    setErreur(null);
    setOccupe(true);
    try {
      await connexion(login, motDePasse);
      naviguer('/', { replace: true });
    } catch (e) {
      setErreur(e instanceof ErreurApi ? e.message : 'Connexion impossible pour le moment.');
    } finally {
      setOccupe(false);
    }
  }

  return (
    <div className="connexion">
      {/* Volet d'encre : l'identité du grand livre, sur une trame réglée. */}
      <aside className="connexion__volet" aria-hidden="true">
        <div className="connexion__enseigne">
          <span className="connexion__sigle">
            GSM<i>.</i>
          </span>
          <span className="connexion__baseline">Gestion sous mandat</span>
        </div>
        <div className="connexion__pied">
          <span>Société de gestion</span>
          <span>Place de Casablanca</span>
        </div>
      </aside>

      {/* Volet parchemin : la saisie. */}
      <main className="connexion__saisie">
        <div className="connexion__carte">
          <p className="surtitre connexion__eyebrow">Accès réservé</p>
          <h1 className="connexion__titre">Ouvrir une session</h1>
          <p className="connexion__sous">
            Application interne de la société de gestion. Vos actions sont journalisées.
          </p>

          {erreur && (
            <BandeauAlerte nature="refus" titre="Connexion refusée">
              {erreur}
            </BandeauAlerte>
          )}

          <form onSubmit={(e) => void soumettre(e)} noValidate>
            <Champ
              label="Identifiant"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
            <Champ
              label="Mot de passe"
              type="password"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              className="bouton bouton--pleine-largeur connexion__bouton"
              type="submit"
              disabled={occupe}
            >
              {occupe ? 'Connexion…' : 'Se connecter'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
